/**
 * Aprende home — scroll horizontal con cards fijas en tablet/móvil (<1024px).
 */
(function () {
  'use strict';

  var COMPACT_MQ = '(max-width: 1023px)';

  function getCards(track) {
    return track.querySelectorAll('.oleum-aprender__card');
  }

  function initRoot(root) {
    if (root.getAttribute('data-oleum-aprender-carousel-init') === '1') {
      refreshRoot(root);
      return;
    }
    root.setAttribute('data-oleum-aprender-carousel-init', '1');

    var viewport = root.querySelector('[data-oleum-aprender-viewport]');
    var track = root.querySelector('[data-oleum-aprender-track]');
    var dotsWrap = root.querySelector('[data-oleum-aprender-dots]');
    var prevBtn = root.querySelector('[data-oleum-aprender-prev]');
    var nextBtn = root.querySelector('[data-oleum-aprender-next]');
    if (!viewport || !track || !dotsWrap) return;

    var mqCompact = window.matchMedia(COMPACT_MQ);
    var state = { active: 0, dots: [] };

    function cards() {
      return getCards(track);
    }

    function isCompact() {
      return mqCompact.matches;
    }

    function slideLeft(index) {
      var list = cards();
      var el = list[index];
      if (!el) return 0;
      return el.offsetLeft;
    }

    function scrollToIndex(i, behavior) {
      var list = cards();
      if (i < 0 || i >= list.length) return;
      state.active = i;
      var left = slideLeft(i);
      if (typeof viewport.scrollTo === 'function') {
        viewport.scrollTo({ left: left, behavior: behavior || 'smooth' });
      } else {
        viewport.scrollLeft = left;
      }
      updateUi();
    }

    function updateNav() {
      var list = cards();
      var n = list.length;
      var compact = isCompact() && n > 1;
      if (prevBtn) {
        prevBtn.hidden = !compact;
        prevBtn.disabled = !compact || state.active <= 0;
      }
      if (nextBtn) {
        nextBtn.hidden = !compact;
        nextBtn.disabled = !compact || state.active >= n - 1;
      }
    }

    function refreshCarouselState() {
      if (!isCompact()) {
        viewport.scrollLeft = 0;
        state.active = 0;
      } else if (state.active >= cards().length) {
        state.active = Math.max(0, cards().length - 1);
      }
      updateDots();
    }

    function updateDots() {
      var list = cards();
      var n = list.length;
      var compact = isCompact() && n > 1;

      if (!compact) {
        dotsWrap.setAttribute('hidden', '');
        dotsWrap.setAttribute('aria-hidden', 'true');
        dotsWrap.innerHTML = '';
        state.dots = [];
        updateNav();
        return;
      }

      if (state.dots.length !== n) {
        dotsWrap.innerHTML = '';
        state.dots = [];
        for (var i = 0; i < n; i++) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'oleum-aprender__dot' + (i === state.active ? ' is-active' : '');
          btn.setAttribute('aria-label', 'Artículo ' + (i + 1));
          btn.setAttribute('aria-selected', i === state.active ? 'true' : 'false');
          btn.setAttribute('role', 'tab');
          (function (idx) {
            btn.addEventListener('click', function () {
              scrollToIndex(idx);
            });
          })(i);
          dotsWrap.appendChild(btn);
          state.dots.push(btn);
        }
      }

      state.dots.forEach(function (dot, j) {
        dot.classList.toggle('is-active', j === state.active);
        dot.setAttribute('aria-selected', j === state.active ? 'true' : 'false');
      });

      dotsWrap.removeAttribute('hidden');
      dotsWrap.setAttribute('aria-hidden', 'false');
      updateNav();
    }

    function syncActiveFromScroll() {
      if (!isCompact()) return;
      var list = cards();
      if (!list.length) return;
      var scrollL = viewport.scrollLeft;
      var active = 0;
      var best = Infinity;
      for (var i = 0; i < list.length; i++) {
        var d = Math.abs(slideLeft(i) - scrollL);
        if (d < best) {
          best = d;
          active = i;
        }
      }
      state.active = active;
      updateUi(false);
    }

    function updateUi(rebuildDots) {
      if (rebuildDots !== false) updateDots();
      else {
        state.dots.forEach(function (dot, j) {
          dot.classList.toggle('is-active', j === state.active);
          dot.setAttribute('aria-selected', j === state.active ? 'true' : 'false');
        });
        updateNav();
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollToIndex(state.active - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollToIndex(state.active + 1);
      });
    }

    var scrollT;
    viewport.addEventListener(
      'scroll',
      function () {
        clearTimeout(scrollT);
        scrollT = setTimeout(syncActiveFromScroll, 80);
      },
      { passive: true }
    );

    var resizeT;
    window.addEventListener(
      'resize',
      function () {
        clearTimeout(resizeT);
        resizeT = setTimeout(refreshCarouselState, 120);
      },
      { passive: true }
    );

    function onMqChange() {
      refreshCarouselState();
    }

    if (typeof mqCompact.addEventListener === 'function') {
      mqCompact.addEventListener('change', onMqChange);
    } else if (typeof mqCompact.addListener === 'function') {
      mqCompact.addListener(onMqChange);
    }

    root._oleumAprenderCarousel = {
      refresh: function () {
        state.active = 0;
        viewport.scrollLeft = 0;
        updateDots();
      }
    };

    if (typeof MutationObserver === 'function') {
      var mo = new MutationObserver(function () {
        clearTimeout(root._oleumAprenderMoT);
        root._oleumAprenderMoT = setTimeout(refreshCarouselState, 60);
      });
      mo.observe(track, { childList: true, subtree: true });
    }

    refreshCarouselState();
  }

  function refreshRoot(root) {
    if (root && root._oleumAprenderCarousel && root._oleumAprenderCarousel.refresh) {
      root._oleumAprenderCarousel.refresh();
      return;
    }
    initRoot(root);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-oleum-aprender-root]').forEach(initRoot);
  }

  window.OleumAprenderCarousel = { boot: boot, refresh: refreshRoot };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
